import React from 'react';
import { Translate } from 'react-redux-i18n';
import { Grid, Row, Col, Panel, Breadcrumb, Button } from 'react-bootstrap';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import { connect } from 'react-redux';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { fetchDashboardMessages, postDashboardMessage, setField } from '../../actions/dashboard_actions';
import Spinner from '../Widgets/spinner';
import moment from 'moment';
import { SkyLightStateless } from 'react-skylight';
import { Data, Toolbar } from 'react-data-grid-addons';
import ReactDataGrid from 'react-data-grid';
import { companyCodeTitle } from '../../actions/root_url'
import axios from 'axios';
import { BASE_USER_URL, DASHBOARD_AP_URL, DASHBOARD_TRANSFER_URL, DASHBOARD_MFG_URL, DASHBOARD_MR_URL, DASHBOARD_OUTSOURCED_URL, DASHBOARD_PR_URL, DASHBOARD_PURCHASE_ORDER_URL, DASHBOARD_PURCHASE_RETURN_URL, DASHBOARD_SALES_ORDER_URL, DASHBOARD_SCRAP_URL } from '../../actions/url';
import CashFormatter from '../Common/cashFormatter';
import PropTypes from 'prop-types';
import checkPermission from '../Common/permissions';
import { resetCurrentSalesOrder, selectSalesOrder } from '../../actions/sales_actions';
import { resetCurrentPurchaseReturn, selectPurchaseReturn } from '../../actions/purchaseReturns_actions';
import ReactDOM from 'react-dom';

const DateFormatter = React.createClass({
  render() {
    if (this.props.value) {
      const date = new Date(this.props.value);
      return <span>{date.toString().slice(4, 15)}</span>;
    }
    return <span className="label label-danger">-</span>;
  },
});
class GeneralDashboardVAK extends React.Component {
  static contextTypes = {
    router: React.PropTypes.object,
  };
  constructor() {
    super();
    this.state = {
      Messages: [],
      userMessage: "",
      userSelectVisibility: false,
      cursorPosition: 0,
      userOptions: {
        rows: [],
        selectedRows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },
    }
  }
  componentDidMount() {
    document.title = companyCodeTitle;
    this.props.fetchDashboardMessages(this.props.selectedCompany && this.props.selectedCompany.value);
    this.fetchUsers();
  }
  componentDidUpdate(prevProps) {
    if (this.props.selectedCompany !== prevProps.selectedCompany) {
      this.props.fetchDashboardMessages(this.props.selectedCompany && this.props.selectedCompany.value);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.messages && nextProps.messages !== this.props.messages) {
      const Messages = nextProps.messages;
      this.setState({ Messages }, () => {
        this.updateScroll();
      });
    }
  }
  fetchUsers() {
    let {userOptions} = this.state;
    userOptions.rows = [];
    axios.get(
      `${BASE_USER_URL}users/?Company_id=${this.props.selectedCompany && this.props.selectedCompany.value}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then(res => {
        res && res.data && res.data.map((r,i) => {
          // userOptions.rows.push({name: r.FirstName + r.LastName, username: r.username});
          userOptions.rows.push({FullName: r.FirstName + ' ' + r.LastName, ...r});
        });
        this.setState({ userOptions });
      }, (err) => {
        if (err.data) {
        } else {
          alert("Server issue detected, please contact admin.");
        }
      })
  }
  updateScroll() {
    const element = document.getElementById('message-box');
    if(element) {
      element.scrollTop = element.scrollHeight;
    }
  }
  renderPOTable = () => {
    const hasPermission = checkPermission('review_po') || checkPermission('approve_po');
    if (!hasPermission) {
      return null;
    }
    // Column difinition
    const columns = [
      {
        key: 'order_num',
        name: <Translate value="po_num" />,
        resizable: true,
        sortable: true,
        // width: 160,
        getRowMetaData: row => row,
        formatter: ({ value, dependentValues }) => {
          return <a href={`/purchaseOrder/${dependentValues.id}`}><span style={{ backgroundColor: 'rgb(172, 223, 139)', color: 'black' }} >{value}</span></a>
        }
      },
      {
        key: 'vendor_name',
        name: <Translate value="vendor"/>,
        resizable: true,
        sortable: true,
        // width: 160,
      },
      {
        key: 'final_price',
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        // width: 90,
        formatter: CashFormatter,
      },
      {
        key: 'post_datetime',
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        // width: 90,
        formatter: DateFormatter,
      },
      {
        key: 'ETA_datetime',
        name: <Translate value="ETA" />,
        resizable: true,
        sortable: true,
        // width: 90,
        formatter: DateFormatter,
      },
      {
        key: 'order_status',
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 110,
      },
    ];

    return (
      <DataTable
        translateTitle={'purchase_order'}
        columns={columns}
        url={DASHBOARD_PURCHASE_ORDER_URL}
        rowKey={'PurchaseOrder_id'}
      />
    );
  }
  renderSOTable = () => {
    const hasPermission = checkPermission('req_review_sales_order') || checkPermission('req_approve_sales_order') || checkPermission('review_sales_order') || checkPermission('approve_sales_order');
    if (!hasPermission) {
      return null;
    }
    const columns = [
      {
        key: 'SONum',
        name: <Translate value="so_no" />,
        resizable: true,
        sortable: true,
        width: 120,
        getRowMetaData: row => row,
        formatter: ({ value, dependentValues }) => {
          return <div onClick={() => {
            this.props.resetCurrentSalesOrder();
            this.props.selectSalesOrder(dependentValues);
            this.context.router.push(`/salesOrders/${dependentValues.SalesOrder_id}`);
          }}><span style={{ backgroundColor: 'rgb(172, 223, 139)' }} >{value}</span></div>
        }
      },
      {
        key: 'customer_name',
        name: <Translate value="customer" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: 'FinalPrice',
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 90,
        formatter: CashFormatter,
      },
      {
        key: 'OrderDate',
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 90,
        formatter: DateFormatter,
      },
      {
        key: 'DispatchDate',
        name: <Translate value="dispatch" />,
        resizable: true,
        sortable: true,
        width: 90,
        formatter: DateFormatter,
      },
      {
        key: 'SaleStatus',
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 110,
      },
    ];
    return (
      <DataTable
        translateTitle={'sales_order'}
        columns={columns}
        url={DASHBOARD_SALES_ORDER_URL}
        rowKey={'SalesOrder_id'}
      />
    )
  }
  renderMFGTable = () => {
    const hasPermission = checkPermission('review_mfg') || checkPermission('approve_mfg');
    if (!hasPermission) {
      return null;
    }
    const columns = [
      {
        key: 'MfgNum',
        name: <Translate value="mfg_num" />,
        resizable: true,
        sortable: true,
        // width: 120,
        getRowMetaData: row => row,
        formatter: ({ value, dependentValues }) => {
          return <a href={`/MFG/${dependentValues.MfgOrder_id}`}><span style={{ backgroundColor: 'rgb(172, 223, 139)', color: 'black' }} >{value}</span></a>
        }
      },
      {
        key: 'OrderDate',
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        // width: 90,
        formatter: DateFormatter,
      },
      {
        key: 'End_Date',
        name: <Translate value="end_date" />,
        resizable: true,
        sortable: true,
        // width: 90,
        formatter: DateFormatter,
      },
      {
        key: 'MfgStatus',
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        // width: 110,
      },
    ];
    return (
      <DataTable
        translateTitle={'mfg_order'}
        columns={columns}
        url={DASHBOARD_MFG_URL}
        rowKey={'MfgOrder_id'}
      />
    )
  }
  renderPRTable = () => {
    const hasPermission = checkPermission('req_review_pr') || checkPermission('req_approve_pr') || checkPermission('review_pr') || checkPermission('approve_pr');
    if (!hasPermission) {
      return null;
    }
    const columns = [
      {
        key: 'order_num',
        name: <Translate value="order_num" />,
        resizable: true,
        sortable: true,
        // width: 120,
        getRowMetaData: row => row,
        formatter: ({ value, dependentValues }) => {
          return <a href={`/PR/${dependentValues.id}`}><span style={{ backgroundColor: 'rgb(172, 223, 139)', color: 'black' }} >{value}</span></a>
        }
      },
      {
        key: 'OrderDate',
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        // width: 90,
        formatter: DateFormatter,
      },
      {
        key: 'Expected_Delivery_Date',
        name: <Translate value="exp_delivery_date" />,
        resizable: true,
        sortable: true,
        // width: 90,
        formatter: DateFormatter,
      },
      {
        key: 'order_status',
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        // width: 110,
      },
    ];
    return (
      <DataTable
        translateTitle={'purchase_requisition'}
        columns={columns}
        url={DASHBOARD_PR_URL}
        rowKey={'id'}
      />
    )
  }
  renderMRTable = () => {
    const hasPermission = checkPermission('review_mr') || checkPermission('approve_mr');
    if (!hasPermission) {
      return null;
    }
    const columns = [
      {
        key: 'MrNum',
        name: <Translate value="order_num" />,
        resizable: true,
        sortable: true,
        // width: 120,
        getRowMetaData: row => row,
        formatter: ({ value, dependentValues }) => {
          return <a href={`/MR/${dependentValues.MrOrder_id}`}><span style={{ backgroundColor: 'rgb(172, 223, 139)', color: 'black' }} >{value}</span></a>
        }
      },
      {
        key: 'MfgNum',
        name: <Translate value="mfg_no" />,
        resizable: true,
        sortable: true,
        // width: 90,
      },
      {
        key: 'OrderDate',
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        // width: 90,
        formatter: DateFormatter,
      },
      {
        key: 'MrStatus',
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        // width: 110,
      },
    ];
    return (
      <DataTable
        translateTitle={'material_requisition'}
        columns={columns}
        url={DASHBOARD_MR_URL}
        rowKey={'MrOrder_id'}
      />
    )
  }
  renderOutsourcedTable = () => {
    const hasPermission = checkPermission('review_out') || checkPermission('approve_out');
    if (!hasPermission) {
      return null;
    }
    const columns = [
      {
        key: 'OutsourcingNum',
        name: <Translate value="order_num" />,
        resizable: true,
        sortable: true,
        // width: 120,
        getRowMetaData: row => row,
        formatter: ({ value, dependentValues }) => {
          return <a href={`/outsourced/${dependentValues.Outsourcing_id}`}><span style={{ backgroundColor: 'rgb(172, 223, 139)', color: 'black' }} >{value}</span></a>
        }
      },
      {
        key: 'VendorName',
        name: <Translate value="vendor" />,
        resizable: true,
        sortable: true,
        // width: 90,
      },
      {
        key: 'OrderDate',
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        // width: 90,
        formatter: DateFormatter,
      },
      {
        key: 'OutsourcingStatus',
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        // width: 110,
      },
    ];
    return (
      <DataTable
        translateTitle={'outsourced_order'}
        columns={columns}
        url={DASHBOARD_OUTSOURCED_URL}
        rowKey={'Outsourcing_id'}
      />
    )
  }
  renderScrapTable = () => {
    const hasPermission = checkPermission('review_scrap') || checkPermission('approve_scrap');
    if (!hasPermission) {
      return null;
    }
    const columns = [
      {
        key: 'ScrapNum',
        name: <Translate value="order_num" />,
        resizable: true,
        sortable: true,
        // width: 120,
        getRowMetaData: row => row,
        formatter: ({ value, dependentValues }) => {
          return <a href={`/scrap/${dependentValues.ScrapOrder_id}`}><span style={{ backgroundColor: 'rgb(172, 223, 139)', color: 'black' }} >{value}</span></a>
        }
      },
      {
        key: 'ScrapReason',
        name: <Translate value="reason" />,
        resizable: true,
        sortable: true,
        // width: 90,
      },
      {
        key: 'OrderDate',
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        // width: 90,
        formatter: DateFormatter,
      },
      {
        key: 'ScrapStatus',
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        // width: 110,
      },
    ];
    return (
      <DataTable
        translateTitle={'scrap_order'}
        columns={columns}
        url={DASHBOARD_SCRAP_URL}
        rowKey={'ScrapOrder_id'}
      />
    )
  }
  renderReturnTable = () => {
    const hasPermission = checkPermission('review_purchase_return') || checkPermission('approve_purchase_return');
    if (!hasPermission) {
      return null;
    }
    const columns = [
      {
        key: 'PRNum',
        name: <Translate value="order_num" />,
        resizable: true,
        sortable: true,
        // width: 120,
        getRowMetaData: row => row,
        formatter: ({ value, dependentValues }) => {
          return <div onClick={() => {
            this.props.resetCurrentPurchaseReturn();
            this.props.selectPurchaseReturn(dependentValues);
            this.context.router.push(`/purchaseReturn/${dependentValues.PurchaseReturn_id}`);
          }}><span style={{ backgroundColor: 'rgb(172, 223, 139)' }} >{value}</span></div>
        }
      },
      {
        key: 'ReturnReason',
        name: <Translate value="reason" />,
        resizable: true,
        sortable: true,
        // width: 90,
      },
      {
        key: 'PostingDate',
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        // width: 90,
        formatter: DateFormatter,
      },
      {
        key: 'ReturnStatus',
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        // width: 110,
      },
    ];
    return (
      <DataTable
        translateTitle={'purchase_return'}
        columns={columns}
        url={DASHBOARD_PURCHASE_RETURN_URL}
        rowKey={'PurchaseReturn_id'}
      />
    )
  }

  renderAPTable = () => {
    const hasPermission = checkPermission('review_ap') || checkPermission('approve_ap');
    if (!hasPermission) {
      return null;
    }
    const renderReveiveNums = reveiveNums => {
      return reveiveNums.map((item) => {
        return (
          <div>
            {item}
          </div>
        );
      })
    }
    const ReceiveNumFormatter = React.createClass({
      render() {
        const {dependentValues: {reveive_nums}} = this.props;
        let reveiveNums = reveive_nums ? reveive_nums.split(',') : []
        return <div>
          {renderReveiveNums(reveiveNums)}
        </div>
      }
    });
    const columns = [
      {
        key: 'payment_num',
        name: <Translate value="order_num" />,
        resizable: true,
        sortable: true,
        // width: 120,
        getRowMetaData: row => row,
        formatter: ({ value, dependentValues }) => {
          return <a href={`/AP/${dependentValues.id}`}><span style={{ backgroundColor: 'rgb(172, 223, 139)', color: 'black' }} >{value}</span></a>
        }
      },
      {
        key: 'reveive_nums',
        name: <Translate value="receive_num" />,
        resizable: true,
        sortable: true,
        // width: 120,
        getRowMetaData: row => row,
        formatter: ReceiveNumFormatter
      },
      {
        key: 'po_no',
        name: <Translate value="po_no" />,
        resizable: true,
        sortable: true,
        // width: 120,
      },
      {
        key: 'payment_amount',
        name: <Translate value="pay_amount" />,
        resizable: true,
        sortable: true,
        // width: 90,
        formatter: CashFormatter,
      },
      {
        key: 'post_datetime',
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        // width: 90,
        formatter: DateFormatter,
      },
      {
        key: 'payment_status',
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        // width: 110,
      },
    ];
    return (
      <DataTable
        translateTitle={'ap'}
        columns={columns}
        url={DASHBOARD_AP_URL}
        rowKey={'id'}
      />
    )
  }
  renderTransferTable = () => {
    const hasPermission = checkPermission('review_transfer') || checkPermission('approve_transfer');
    if (!hasPermission) {
      return null;
    }
    const columns = [
      {
        key: 'transfer_num',
        name: <Translate value="order_num" />,
        resizable: true,
        sortable: true,
        // width: 120,
        getRowMetaData: row => row,
        // formatter: ({ value, dependentValues }) => {
        //   return <a href={`/inventoryTransfer/${dependentValues.Outsourcing_id}`}><span style={{ backgroundColor: 'rgb(172, 223, 139)', color: 'black' }} >{value}</span></a>
        // }
      },
      {
        key: 'tracking_number',
        name: <Translate value="tracking_number" />,
        resizable: true,
        sortable: true,
        // width: 90,
      },
      {
        key: 'transfer_date',
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        // width: 90,
        formatter: DateFormatter,
      },
      {
        key: 'order_status',
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        // width: 110,
      },
    ];
    return (
      <DataTable
        translateTitle={'transfer_order'}
        columns={columns}
        url={DASHBOARD_TRANSFER_URL}
        rowKey={'Transfer_id'}
      />
    )
  }

  addNewMessage2 = () => {
    const newMessage = {
      message: this.state.userMessage,
    };
    this.props.postDashboardMessage(newMessage);
    this.setState({userMessage: ""});
  }
  updateSelectedUserMessage = e => {
    this.setState({userMessage: e.target.value});
  }
  setUserSelectVisibility = (userSelectVisibility = false) => {
    const textField = document.getElementById('ats');
    // const cursorPosition = textField.selectionStart;
    this.setState({ userSelectVisibility, cursorPosition: textField.selectionStart+1 });
  }
  renderMessages = () => {
    if (this.props.messagesIsLoading) {
      return (
        <Spinner />
      );
    }

    return (
      <Col xs={12}>
        {this.state.Messages.map((message) =>
          <Row className='user-message' style={{width: '99%'}}>
            <Col xs={11}>
              <Panel>
                <Row>
                  <Col xs={2}>
                    <span className='message-name'>{ message.Name }</span>:
                  </Col>
                  <Col xs={10}>
                    <div>
                      <span className='message-content'>{ message.Message }</span>
                    </div>
                  </Col>
                </Row>
              </Panel>
            </Col>
            <Col xs={1} className='message-timestamp'>
              <Row>
                <Col xs={12}>
                    <span className='pull-right'>
                      { moment(message.Date).format('h:mm A') }
                    </span>
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                    <span className='pull-right'>
                      { moment(message.Date).format('MM/DD/YYYY') }
                    </span>
                </Col>
              </Row>
            </Col>
          </Row>
        )}
      </Col>
    );
  }
  renderUserTable() {
    const getRows = () => {
      const Rows = Data.Selectors.getRows(this.state.userOptions);
      return Rows;
    };

    const getSize = () => {
      const RowSize = getRows().length;
      return RowSize;
    };

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const handleGridSort = (sortColumn, sortDirection) => {
      const userOptions = { ...this.state.userOptions, sortColumn, sortDirection };
      this.setState({ userOptions });
    };

    const onRowSelect = (rows) => {
      const userOptions = { ...this.state.userOptions, selectedRows: rows };
      this.setState({ userOptions });
    };

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.userOptions.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const userOptions = {
        ...this.state.userOptions,
        filters: newFilters,
      };
      this.setState({ userOptions });
    };

    const handleUserClick = (val) => {
      let {userMessage} = this.state;
      // userMessage += val.username + ' ';
      let msg = null;
      msg = userMessage.slice(0, this.state.cursorPosition) + val.username + ' ' + userMessage.slice(this.state.cursorPosition);
      this.setState({userMessage: msg, userSelectVisibility: false});

      document.getElementById('ats').focus();
    }

    const columns = [
      {
        key: 'username',
        name: <Translate value="username" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 140,
        getRowMetaData: row => row,
        formatter: ({ value, dependentValues }) => (
          <div
            style={{ cursor: 'pointer', width: "100%", height: "100%" }}
            onClick={() => {
              handleUserClick(dependentValues);
            }}
          >
            {value}
          </div>
        ),
      },
      {
        key: 'Cellphone',
        name: <Translate value="phone" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 140,
        getRowMetaData: row => row,
        formatter: ({ value, dependentValues }) => (
          <div
            style={{ cursor: 'pointer', width: "100%", height: "100%" }}
            onClick={() => {
              handleUserClick(dependentValues);
            }}
          >
            {value}
          </div>
        ),
      },
    ];

    return (
      // React Table Purchase Orders
      <Row>
        <Col xs={12}>
          {/* <div id="purchase-orders-arriving-table"> */}
          <div style={{ maxWidth: '800px' }}>
            <ReactDataGrid
              toolbar={<Toolbar enableFilter />}
              onAddFilter={handleFilterChange}
              rowKey="PurchaseOrder_id"
              onGridSort={handleGridSort}
              columns={columns}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              minHeight={360}
              rowHeight={25}
              onRowSelect={onRowSelect}
            />
          </div>
        </Col>
      </Row>
    );
  }
  render() {
    const userSelectStyle = {
      width: "300px",
      height: "500px",
      marginLeft: "-20%",
      marginTop: "-380px"
    };
    const messageBoardHeader = (
      <Row>
        <Col xs={12}>
          <h4 style={{ display: 'inline' }}>
            <Translate value="message_board" />
          </h4>
          {this.props.Message && this.props.Message.length > 499 && <div id='limit-warning'><Translate value="character_limit_reached" /> (500)</div>}
          <Button
            bsStyle='primary'
            id='refresh-button'
            onClick={this.props.fetchDashboardMessages}
          >
            <em className='fa fa-refresh' />
          </Button>
        </Col>
      </Row>
    );
    return (
      <ContentWrapper>
        <Breadcrumb>
          <Breadcrumb.Item active="true">
            <Translate value="dashboard" />
          </Breadcrumb.Item>
        </Breadcrumb>
        <Grid id="general-dashboard" fluid="true">
          <Row style={{flexWrap: 'wrap'}}>
            <Col xs={6}>
              {this.renderPOTable()}
            </Col>
            <Col xs={6}>
              {this.renderSOTable()}
            </Col>
            <Col xs={6}>
              <Panel header={messageBoardHeader} id='message-panel'>
                <Row id='message-box'>
                  {this.renderMessages()}
                </Row>
                <Row>
                  <Col xs={11}>
                    <input
                      name="ats" id="ats"
                      value={this.state.userMessage}
                      onChange={(e) => {
                        this.updateSelectedUserMessage(e);
                      }}
                      onKeyDown={(event) => {
                        if (event.key === 'Enter') {
                          if (this.state.userMessage.length > 0) {
                            this.addNewMessage2();
                          }
                        }
                        if (event.key === '@') {
                          this.setUserSelectVisibility(true);
                          setTimeout(() => {
                            document.getElementById('ats')
                              .blur();
                          }, 100);
                        }
                      }}
                      style={{
                        width: '100%',
                        height: '22px',
                        borderRadius: '3px',
                        border: '1px solid black',
                        padding: '5px'
                      }}
                    />
                  </Col>
                  <Col xs={1}>
                    <Button
                      bsStyle="primary"
                      className="pull-right"
                      onClick={this.addNewMessage2}
                    >
                      <em className="fa fa-paper-plane-o"/>
                    </Button>
                  </Col>
                </Row>
              </Panel>
            </Col>
            <Col xs={6}>
              {this.renderMFGTable()}
            </Col>
            <Col xs={6}>
              {this.renderPRTable()}
            </Col>
            <Col xs={6}>
              {this.renderMRTable()}
            </Col>
            <Col xs={6}>
              {this.renderOutsourcedTable()}
            </Col>
            <Col xs={6}>
              {this.renderScrapTable()}
            </Col>
            <Col xs={6}>
              {this.renderReturnTable()}
            </Col>
            <Col xs={6}>
              {this.renderAPTable()}
            </Col>
            <Col xs={6}>
              {this.renderTransferTable()}
            </Col>
          </Row>
        </Grid>
        <SkyLightStateless
          dialogStyles={userSelectStyle}
          isVisible={this.state.userSelectVisibility}
          onCloseClicked={this.setUserSelectVisibility}
          title={"@ User"}
        >
          <div>
            {this.renderUserTable()}
          </div>
        </SkyLightStateless>
      </ContentWrapper>
    )
  }
}

class DataTable extends React.Component {
  constructor() {
    super();
    this.state = {
      data: {
        rows: [],
        sortColumn: null,
        sortDirection: null,
        selectedRows: [],
      },
      error: null,
      isLoading: false,
    }
  }
  componentDidMount() {
    this.fetchData();
  }
  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.params !== this.props.params) {
      this.fetchData();
    }
  }

  fetchData = () => {
    if (!this.props.url) return;
    this.setState({isLoading: true})
    axios.get(this.props.url,
      {
        params: this.props.params,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(response => {
      this.setState({
        error: null,
        isLoading: false,
        data: {...this.state.data, rows: response.data},
      });
    }).catch(error => {
      this.setState({
        error,
        isLoading: false,
      })
    })
  }
  getRows = () => {
    const Rows = Data.Selectors.getRows(this.state.data)
    return Rows;
  };

  getSize = () => {
    const RowSize = this.getRows().length;
    return RowSize;
  };

  rowGetter = (rowIdx) => {
    const rows = this.getRows();
    return rows[rowIdx];
  };

  // Handle the sortable function
  handleGridSort = (sortColumn, sortDirection) => {
    const data = { ...this.state.data, sortColumn, sortDirection };
    this.setState({ data });
  };

  // Handle the row select function
  onRowSelect = (rows) => {
    const data = { ...this.state.data, selectedRows: rows };
    this.setState({ data });
  };
  getRowHeight = (element) => {
    const container = document.createElement('div');
    ReactDOM.render(element, container);
    document.body.appendChild(container);
    const height = +window.getComputedStyle(container).height.replace('px', '');
    ReactDOM.unmountComponentAtNode(container);
    document.body.removeChild(container);
    return height;
  }
  renderReveiveNums = reveiveNums => {
    return reveiveNums.map((item) => {
      return (
        <div>
          {item}
        </div>
      );
    })
  }
  render() {
    if (this.state.error) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">{JSON.stringify(this.state.error)}</div>
        </ContentWrapper>
      ); // Parameters of the react-data-grid
    }
    const tablePanelHeader = (
      <Row>
        <Col xs={5}>{this.props.title ? this.props.title : <h4><Translate value={this.props.translateTitle} /></h4>}</Col>
      </Row>
    );
    const RowRenderer = React.createClass({
      render() {
        let rowHeight = rowHeights[this.props.idx];
        return <ReactDataGrid.Row {...this.props} ref="row" height={rowHeight} />;
      }
    });
    let children = {};
    let rowHeights = []
    if(this.props.url == DASHBOARD_AP_URL) {
      children.rowRenderer = <RowRenderer />
      rowHeights = (this.getRows() || []).map(row => {
        let reveiveNums = (row.reveive_nums || '').split(',')
        const receiveNumColumn = (this.props.columns || []).find(column => column.key === 'reveive_nums');
        let receiveNumRowHeight = 25;
        const ReceiveNumElem = () => <div>{this.renderReveiveNums(reveiveNums)}</div>;
        const receiveNumHeight = this.getRowHeight(<ReceiveNumElem />);
        if (receiveNumHeight) {
          receiveNumRowHeight = receiveNumHeight + (5 * reveiveNums.length)
        }
        return receiveNumRowHeight;
      });
    }

    return (
      <Panel header={tablePanelHeader}>
        <Row>
          <Col xs={12}>
            <div style={{height: 308}}>
              {this.state.isLoading && !this.state.error
                ? <Spinner />
                : <ReactDataGrid
                  rowKey={this.props.rowKey}
                  onGridSort={this.handleGridSort}
                  columns={this.props.columns || []}
                  rowGetter={this.rowGetter}
                  rowsCount={this.getSize()}
                  minHeight={305}
                  onRowSelect={this.onRowSelect}
                  {...children}
                  headerRowHeight={45}
                  rowHeight={this.props.url === DASHBOARD_AP_URL ? rowHeights.reduce((total, height) => total + height, 0) / this.getSize() : 25}
                />}
            </div>
          </Col>
        </Row>
      </Panel>
    )
  }
}
DataTable.propTypes = {
  url: PropTypes.string.isRequired,
  columns: PropTypes.array.isRequired,
  title: PropTypes.element,
  translateTitle: PropTypes.string,
  params: PropTypes.object,
  rowKey: PropTypes.string.isRequired,
}
const selector = formValueSelector('generalDashboard');
const mapStateToProps = state => {
  const Message = selector(state, 'MessageField');
  return {
    Message,
    messages: state.dashboard.messages,
    messagesIsLoading: state.dashboard.messagesIsLoading,
    messagesError: state.dashboard.messagesError,
    selectedCompany: state.header.selectedCompany,
    selectedWarehouse: state.header.selectedWarehouse,
  }
}
export default connect(mapStateToProps, {fetchDashboardMessages, postDashboardMessage, setField, selectSalesOrder, resetCurrentSalesOrder, resetCurrentPurchaseReturn, selectPurchaseReturn})(GeneralDashboardVAK);



// WEBPACK FOOTER //
// ./master/jsx/components/General/generalDashboardVAK.jsx